/**
 * Demo Data Service
 * Provides sample data for demo organizations
 */

// Demo organization ID (special identifier)
export const DEMO_ORG_ID = 'demo-organization'

// Sample clients with varied cases
export const DEMO_CLIENTS = [
  {
    id: 'demo-client-1',
    first_name: 'Sarah',
    last_name: 'Johnson',
    email: 'sarah.johnson@example.com',
    phone: '+1-555-0101',
    date_of_birth: '1985-03-15',
    gender: 'Female',
    created_at: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'demo-client-2',
    first_name: 'Michael',
    last_name: 'Chen',
    email: 'michael.chen@example.com',
    phone: '+1-555-0102',
    date_of_birth: '1978-11-22',
    gender: 'Male',
    created_at: new Date(Date.now() - 75 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'demo-client-3',
    first_name: 'Emily',
    last_name: 'Rodriguez',
    email: 'emily.rodriguez@example.com',
    phone: '+1-555-0103',
    date_of_birth: '1992-07-08',
    gender: 'Female',
    created_at: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'demo-client-4',
    first_name: 'David',
    last_name: 'Thompson',
    email: 'david.thompson@example.com',
    phone: '+1-555-0104',
    date_of_birth: '1980-01-30',
    gender: 'Male',
    created_at: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'demo-client-5',
    first_name: 'Lisa',
    last_name: 'Anderson',
    email: 'lisa.anderson@example.com',
    phone: '+1-555-0105',
    date_of_birth: '1988-09-14',
    gender: 'Female',
    created_at: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
  },
]

// Sample examinations with varied cases
export const DEMO_EXAMINATIONS = [
  {
    id: 'demo-exam-1',
    client_id: 'demo-client-1',
    created_at: new Date(Date.now() - 85 * 24 * 60 * 60 * 1000).toISOString(),
    vital_signs: {
      bloodPressure: '118/76',
      heartRate: '72',
      respiratoryRate: '16',
      temperature: '36.8',
      oxygenSaturation: '98',
      weight: '65',
      height: '165',
      bmi: '23.9',
    },
    medical_history: {
      current_medications: 'Multivitamin, Omega-3',
      allergies: 'None known',
      chronic_conditions: 'Mild anxiety',
      primary_goals: 'Improve sleep quality and reduce stress',
    },
  },
  {
    id: 'demo-exam-2',
    client_id: 'demo-client-2',
    created_at: new Date(Date.now() - 70 * 24 * 60 * 60 * 1000).toISOString(),
    vital_signs: {
      bloodPressure: '132/84',
      heartRate: '78',
      respiratoryRate: '18',
      temperature: '37.1',
      oxygenSaturation: '97',
      weight: '82',
      height: '178',
      bmi: '25.9',
    },
    medical_history: {
      current_medications: 'Blood pressure medication',
      allergies: 'Penicillin',
      chronic_conditions: 'Hypertension, Type 2 Diabetes',
      primary_goals: 'Manage blood pressure and improve diet',
    },
  },
  {
    id: 'demo-exam-3',
    client_id: 'demo-client-3',
    created_at: new Date(Date.now() - 55 * 24 * 60 * 60 * 1000).toISOString(),
    vital_signs: {
      bloodPressure: '110/70',
      heartRate: '68',
      respiratoryRate: '14',
      temperature: '36.6',
      oxygenSaturation: '99',
      weight: '58',
      height: '162',
      bmi: '22.1',
    },
    medical_history: {
      current_medications: 'Birth control',
      allergies: 'None',
      chronic_conditions: 'None',
      primary_goals: 'Maintain healthy lifestyle and energy levels',
    },
  },
  {
    id: 'demo-exam-4',
    client_id: 'demo-client-4',
    created_at: new Date(Date.now() - 40 * 24 * 60 * 60 * 1000).toISOString(),
    vital_signs: {
      bloodPressure: '125/80',
      heartRate: '75',
      respiratoryRate: '17',
      temperature: '37.0',
      oxygenSaturation: '98',
      weight: '88',
      height: '180',
      bmi: '27.2',
    },
    medical_history: {
      current_medications: 'None',
      allergies: 'Shellfish',
      chronic_conditions: 'Lower back pain',
      primary_goals: 'Reduce back pain and improve mobility',
    },
  },
  {
    id: 'demo-exam-5',
    client_id: 'demo-client-5',
    created_at: new Date(Date.now() - 25 * 24 * 60 * 60 * 1000).toISOString(),
    vital_signs: {
      bloodPressure: '115/75',
      heartRate: '70',
      respiratoryRate: '15',
      temperature: '36.9',
      oxygenSaturation: '98',
      weight: '62',
      height: '168',
      bmi: '22.0',
    },
    medical_history: {
      current_medications: 'Iron supplement',
      allergies: 'None',
      chronic_conditions: 'Iron deficiency anemia',
      primary_goals: 'Increase energy and improve iron levels',
    },
  },
]

// Sample care plans
export const DEMO_CARE_PLANS = [
  {
    id: 'demo-careplan-1',
    client_id: 'demo-client-1',
    title: 'Stress Management & Sleep Improvement',
    status: 'active',
    created_at: new Date(Date.now() - 80 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'demo-careplan-2',
    client_id: 'demo-client-2',
    title: 'Hypertension & Diabetes Management',
    status: 'active',
    created_at: new Date(Date.now() - 65 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'demo-careplan-3',
    client_id: 'demo-client-3',
    title: 'Wellness Maintenance Plan',
    status: 'active',
    created_at: new Date(Date.now() - 50 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'demo-careplan-4',
    client_id: 'demo-client-4',
    title: 'Back Pain Relief Program',
    status: 'in_progress',
    created_at: new Date(Date.now() - 35 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'demo-careplan-5',
    client_id: 'demo-client-5',
    title: 'Iron Deficiency Recovery Plan',
    status: 'active',
    created_at: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000).toISOString(),
  },
]

// Sample therapies
export const DEMO_THERAPIES = [
  {
    id: 'demo-therapy-1',
    client_id: 'demo-client-1',
    name: 'Acupuncture Session',
    scheduled_date: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    time_of_day: '10:00 AM',
    status: 'scheduled',
  },
  {
    id: 'demo-therapy-2',
    client_id: 'demo-client-2',
    name: 'Nutrition Consultation',
    scheduled_date: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    time_of_day: '2:00 PM',
    status: 'scheduled',
  },
  {
    id: 'demo-therapy-3',
    client_id: 'demo-client-3',
    name: 'Herbal Medicine Review',
    scheduled_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    time_of_day: '11:00 AM',
    status: 'scheduled',
  },
  {
    id: 'demo-therapy-4',
    client_id: 'demo-client-4',
    name: 'Physical Therapy Session',
    scheduled_date: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    time_of_day: '3:00 PM',
    status: 'scheduled',
  },
  {
    id: 'demo-therapy-5',
    client_id: 'demo-client-5',
    name: 'Follow-up Consultation',
    scheduled_date: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    time_of_day: '9:00 AM',
    status: 'scheduled',
  },
]

// Sample sessions
export const DEMO_SESSIONS = [
  {
    id: 'demo-session-1',
    client_id: 'demo-client-1',
    session_date: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    focus_area: 'Stress management techniques',
    outcome_summary: 'Client showed improvement in sleep quality after implementing relaxation techniques.',
  },
  {
    id: 'demo-session-2',
    client_id: 'demo-client-2',
    session_date: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    focus_area: 'Dietary modifications',
    outcome_summary: 'Discussed meal planning strategies for diabetes management.',
  },
  {
    id: 'demo-session-3',
    client_id: 'demo-client-3',
    session_date: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    focus_area: 'Wellness maintenance',
    outcome_summary: 'Reviewed current health status and maintained wellness goals.',
  },
  {
    id: 'demo-session-4',
    client_id: 'demo-client-4',
    session_date: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    focus_area: 'Back pain assessment',
    outcome_summary: 'Assessed progress and adjusted treatment plan for back pain relief.',
  },
  {
    id: 'demo-session-5',
    client_id: 'demo-client-5',
    session_date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    focus_area: 'Iron levels monitoring',
    outcome_summary: 'Reviewed blood test results and adjusted supplement regimen.',
  },
]

/**
 * Check if organization is demo
 */
export const isDemoOrganization = (organization) => {
  if (!organization) return false
  return organization.id === DEMO_ORG_ID || 
         organization.subscription_tier === 'demo' ||
         (organization.subscription && organization.subscription.tier === 'demo')
}

/**
 * Get demo clients
 */
export const getDemoClients = () => {
  return DEMO_CLIENTS
}

/**
 * Get demo examinations for a client
 */
export const getDemoExaminations = (clientId = null) => {
  if (clientId) {
    return DEMO_EXAMINATIONS.filter((exam) => exam.client_id === clientId)
  }
  return DEMO_EXAMINATIONS
}

/**
 * Get demo care plans for a client
 */
export const getDemoCarePlans = (clientId = null) => {
  if (clientId) {
    return DEMO_CARE_PLANS.filter((plan) => plan.client_id === clientId)
  }
  return DEMO_CARE_PLANS
}

/**
 * Get demo therapies for a client
 */
export const getDemoTherapies = (clientId = null) => {
  if (clientId) {
    return DEMO_THERAPIES.filter((therapy) => therapy.client_id === clientId)
  }
  return DEMO_THERAPIES
}

/**
 * Get demo sessions for a client
 */
export const getDemoSessions = (clientId = null) => {
  if (clientId) {
    return DEMO_SESSIONS.filter((session) => session.client_id === clientId)
  }
  return DEMO_SESSIONS
}

/**
 * Get demo client by ID
 */
export const getDemoClient = (clientId) => {
  return DEMO_CLIENTS.find((client) => client.id === clientId)
}

